import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { PARAMETERS_INIT_FAIL, BENEFIT_INIT_LOADING, BENEFIT_INIT_SUCCESS, BENEFIT_INIT_FAIL } from '@/store/types'
export const benefit = {
  async benefitInit({ commit, state }) {
    const apiUrl = state.menu.benefit
    if (apiUrl) {
      commit(BENEFIT_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(BENEFIT_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(BENEFIT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PARAMETERS_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  }
}
